import { Component, Input, OnInit } from '@angular/core';
import { QQQuestionnaireViewModel } from 'src/app/models/qq-questionnaire.view-model';
import { QuickQuoteResult } from 'src/app/models/quick-quote-result';
import { QuoteModel } from 'src/app/models/quote.model';
import { SiteContentService } from 'src/app/services/site-content.service';

@Component({
  selector: 'app-apg-quick-quote-result',
  templateUrl: './apg-quick-quote-result.component.html',
  styleUrls: ['./apg-quick-quote-result.component.scss'],
})
export class ApgQuickQuoteResultComponent implements OnInit {

  @Input() quote: QuoteModel;
  @Input() quickQuote: QQQuestionnaireViewModel;
  @Input() page: string;
  @Input() title: string = "Life Cover";

  answersObject: any;
  result: QuickQuoteResult;
  illnessCover: string;
  coverFor: string;
  protectionLevel_1: string;
  policyTerm_1: string;
  addressLines: string[];

  constructor(
    private siteContentService: SiteContentService
  ) { }

  async ngOnInit() {
    await this.setupContent();
  }

  OnViewDidEnter() {
    this.answersObject = null;
  }

  async setupContent() {
    try {
      this.result = this.quote?.result;
      this.answersObject = this.quickQuote.answersObject;
      this.setAddressLines();
    } catch (err) {
      let content = await this.siteContentService.getSiteContent("FullQuote.Error");
      this.result = { error: content.body };
    } 
  }

  setAddressLines() {
    const ans = (key: string) => this.answersObject[key] || '';

    this.addressLines = [
      `${ans('AddressSubBuilding')} ${ans('AddressBuildingName')}`,
      `${ans('AddressBuildingNumber')} ${ans('AddressStreet')}`,
      ans('AddressCity'),
      ans('AddressCounty'),
      ans('AddressPostCode')
    ]
      .map(x => x?.trim())
      .filter(x => x?.length > 0);
  }

}
